import React from "react";
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useCreateCampaignMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Form as FormLayout } from "react-bootstrap";
import TextInput from "../../../Common/components/text-input";
import DateInput from "../../../Common/components/date-input";
import SelectInput from "../../../Common/components/select-input";
import { format } from "date-fns";
import Select from "react-select";

const CreateCampaignModal = ({ showCreateCampaignModal, onHide }) => {
    const [createCampaign, { isLoading }] = useCreateCampaignMutation();

    const validationSchema = Yup.object({
        startDate: Yup.date().required('Start Date is required'),
        endDate: Yup.date().required('End Date is required'),
    });

    return (
        <Modal
            show={showCreateCampaignModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isLoading ? "static" : true}
            keyboard={!isLoading}
        >
            <Formik
                initialValues={{
                    startDate: "",
                    endDate: "",
                    name: "",
                    type: "",
                    timeline: "",
                    description: "",
                    colorCode: "",
                    durationType: "",
                    recurrentDays: [],
                    target: 0,
                    rewardAmount: 0,
                    rewardCurrency: "GEMS",
                    userGroup: "trove",
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    const payload = {
                        ...values,
                        startDate: format(new Date(values.startDate), "yyyy-MM-dd HH:mm:ss"),
                        endDate: format(new Date(values.endDate), "yyyy-MM-dd HH:mm:ss"),
                        recurrentDays: values.recurrentDays.map(Number),
                    };
                    createCampaign(payload)
                        .unwrap()
                        .then(() => {
                            cogoToast.success("Campaign action created successfully");
                            onHide();
                        })
                        
                }}
            >
                {({ isValid, values, handleChange, setFieldValue }) => (
                    <Form noValidate>
                        <Modal.Header>
                            <Modal.Title id="contained-modal-title-vcenter">
                                <span className="svg-icon svg-icon-lg svg-icon-primary mr-3">
                                    <SVG
                                        title=""
                                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Safe.svg")}
                                    />
                                </span>
                                Create Campaign
                            </Modal.Title>
                            <button type="button" className="close" onClick={onHide}>
                                <span aria-hidden="true" className="d-block">×</span>
                                <span className="sr-only">Close</span>
                            </button>
                        </Modal.Header>
                        <Modal.Body className="px-10 py-2">
                            <FormLayout.Row className="d-flex flex-wrap">
                                <div style={{ width: "50%" }} className="pr-2">
                                    <TextInput label="Name" name="name" onChange={handleChange} />
                                </div>
                                <div style={{ width: "50%" }} className="pl-2">
                                    <TextInput label="Description" name="description" onChange={handleChange} />
                                </div>
                                <div style={{ width: "50%" }} className="pr-2">
                                    <SelectInput
                                        label="Duration Type"
                                        name="durationType"
                                        options={["FIXED", "FLASH"]}
                                        onChange={(event) => {
                                            handleChange(event);
                                            if (event.target.value === "FLASH") {
                                                setFieldValue("timeline", "DAILY");
                                            }
                                        }}
                                    />
                                </div>
                                {values.durationType === "FLASH" && (
                                    <div className="w-100" style={{ marginBottom: "20px" }}>
                                        <label htmlFor="recurrentDays" className="form-label">
                                            Recurring Days
                                        </label>
                                        <Select
                                            id="recurrentDays"
                                            isMulti
                                            isClearable
                                            options={[
                                                { label: "Monday", value: 1 },
                                                { label: "Tuesday", value: 2 },
                                                { label: "Wednesday", value: 3 },
                                                { label: "Thursday", value: 4 },
                                                { label: "Friday", value: 5 },
                                                { label: "Saturday", value: 6 },
                                                { label: "Sunday", value: 7 },
                                            ]}
                                            onChange={(selectedOptions) => {
                                                const selectedValues = selectedOptions
                                                    ? selectedOptions.map((option) => option.value)
                                                    : [];
                                                setFieldValue("recurrentDays", selectedValues);
                                            }}
                                            value={values.recurrentDays.map((day) => ({
                                                label: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"][day - 1],
                                                value: day,
                                            }))}
                                            className="w-100"
                                            styles={{
                                                container: (base) => ({
                                                    ...base,
                                                    width: "100%",
                                                }),
                                            }}
                                        />
                                    </div>
                                )}
                                <div style={{ width: "50%" }} className="pl-2">
                                    <SelectInput
                                        label="Type"
                                        name="type"
                                        options={["ORDER", "REFERRAL"]}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div style={{ width: "50%" }} className="pr-2">
                                    <SelectInput
                                        label="Timeline"
                                        name="timeline"
                                        options={
                                            values.durationType === "FLASH"
                                                ? ["DAILY"]
                                                : ["WEEKLY", "MONTHLY", "DAILY"]
                                        }
                                        onChange={handleChange}
                                    />
                                </div>
                                <div style={{ width: "50%" }} className="pl-2">
                                    <label htmlFor="colorCode" className="form-label">
                                        Color Code
                                    </label>
                                    <div className="d-flex align-items-center">
                                        <input
                                            type="color"
                                            id="colorPicker"
                                            value={values.colorCode || "#000000"}
                                            onChange={(e) => setFieldValue("colorCode", e.target.value)}
                                            style={{
                                                width: "50px",
                                                height: "36px",
                                                border: "none",
                                                marginRight: "10px",
                                                cursor: "pointer",
                                            }}
                                        />
                                        <input
                                            type="text"
                                            name="colorCode"
                                            className="form-control"
                                            placeholder="#f8uy64"
                                            value={values.colorCode}
                                            onChange={(e) => setFieldValue("colorCode", e.target.value)}
                                            maxLength={7}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: "50%" }} className="pr-2">
                                    <TextInput label="Target" name="target" type="number" min="0" onChange={handleChange} />
                                </div>
                                <div style={{ width: "50%" }} className="pl-2">
                                    <TextInput
                                        label="Reward Amount"
                                        name="rewardAmount"
                                        type="number"
                                        min="0.0"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div style={{ width: "50%" }} className="pr-2">
                                    <DateInput label="Start Date" name="startDate" onChange={handleChange} />
                                </div>
                                <div style={{ width: "50%" }} className="pl-2">
                                    <DateInput label="End Date" name="endDate" onChange={handleChange} />
                                </div>
                            </FormLayout.Row>
                        </Modal.Body>

                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate px-4"
                                disabled={isLoading}
                            >
                                Close
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary btn-elevate px-4 ml-4"
                                disabled={isLoading || !isValid}
                            >
                                Create
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default CreateCampaignModal;